import { useState, useEffect, useReducer } from "react";
import openSocket from "../../services/socket-io";
import toastError from "../../errors/toastError";

import api from "../../services/api";

const reducer = (state, action) => {
	if (action.type === "LOAD_CONNECTIONS") {
		const connections = action.payload;

		return [...connections];
	}

	if (action.type === "UPDATE_CONNECTION") {
		const connection = action.payload;
		if (!connection?.id) return [...state];

		const connectionIndex = state.findIndex(s => s.id === connection.id);

		if (connectionIndex !== -1) {
			state[connectionIndex] = connection;
			return [...state];
		} else {
			return [connection, ...state];
		}
	}

	if (action.type === "UPDATE_SESSION") {
		const connection = action.payload;
		if (!connection?.id) return [...state];

		const connectionIndex = state.findIndex(s => s.id === connection.id);

		if (connectionIndex !== -1) {
			state[connectionIndex].status = connection.status;
			state[connectionIndex].updatedAt = connection.updatedAt;
			state[connectionIndex].qrcode = connection.qrcode;
			state[connectionIndex].retries = connection.retries;
			state[connectionIndex].number = connection.number;
			state[connectionIndex].session = connection.session;
			return [...state];
		} else {
			return [...state];
		}
	}

	if (action.type === "DELETE_CONNECTION") {
		const connectionId = action.payload;

		const connectionIndex = state.findIndex(s => s.id === connectionId);
		if (connectionIndex !== -1) {
			state.splice(connectionIndex, 1);
		}
		return [...state];
	}

	if (action.type === "RESET") {
		return [];
	}

	return state;
};

const useConnections = accountKey => {
	const [connections, dispatch] = useReducer(reducer, []);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		setLoading(true);
		dispatch({ type: "RESET" });

		const fetchSession = async () => {
			try {
				const { data } = await api.get("/connections/");
				dispatch({ type: "LOAD_CONNECTIONS", payload: data });
				setLoading(false);
			} catch (err) {
				setLoading(false);
				toastError(err);
			}
		};
		fetchSession();
	}, [accountKey]);

	useEffect(() => {
		const socket = openSocket();

		socket.on("connection", data => {
			if (data.action === "update") {
				dispatch({
					type: "UPDATE_CONNECTION",
					payload: data.connection || data.whatsapp
				});
			}
		});

		socket.on("connection", data => {
			if (data.action === "delete") {
				dispatch({ type: "DELETE_CONNECTION", payload: data.connectionId });
			}
		});

		socket.on("connectionSession", data => {
			if (data.action === "update") {
				dispatch({ type: "UPDATE_SESSION", payload: data.session });
			}
		});

		return () => {
			socket.disconnect();
		};
	}, [accountKey]);

	return { connections, loading };
};

export default useConnections;

